/**
 * 人像去背景 + AI 换背景（中文全文）
 * supportedLocales 覆盖全部 hub 语言；非 zh/en 正文见 portraitChangerLocales.js
 */

function makeSection(id, title, blocks) {
  return { id: id, title: title, blocks: blocks || [] }
}

function p(text) {
  return { type: 'paragraph', text: text }
}

function bullets(items) {
  return { type: 'bullets', items: items }
}

function links(title, items) {
  return { type: 'links', title: title, items: items }
}

function table(columns, rows, variant) {
  return { type: 'table', columns: columns, rows: rows, variant: variant || 'default' }
}

function tip(title, text) {
  return { type: 'tip', title: title || '实用提示', text: text }
}

function gallery(imageKeys, caption, cols, fit, ratio) {
  var items = (imageKeys || []).map(function (key) {
    return { imageKey: key }
  })
  return {
    type: 'gallery',
    items: items,
    caption: caption || '',
    cols: cols || 2,
    fit: fit || 'contain',
    ratio: ratio || 'portrait'
  }
}

function faqItem(question, answer) {
  return { type: 'faq-item', question: question, answer: answer }
}

function stepsBlock() {
  return { type: 'steps' }
}

function prosConsBlock() {
  return { type: 'pros-cons' }
}

var ARTICLES = [
  {
    slug: 'ai-portrait-background-remover',
    category: 'how-to-guides',
    layout: 'how-to',
    badge: 'Hot',
    supportedLocales: ['zh', 'en', 'ja', 'ko', 'fr', 'es', 'it', 'de', 'pt', 'pl', 'ar'],
    coverImage: 'portrait-linkedin-after',
    heroImage: 'portrait-linkedin-after',
    title: '免费 AI 人像去背景：头像、证件照与 LinkedIn 职业照抠图',
    excerpt: '街拍、会议室自拍也能变干净头像：免费在线去除人像背景，导出透明 PNG，再铺白底、蓝底或品牌色做证件照、简历照和社媒头像。',
    metaTitle: '免费 AI 人像去背景：证件照与头像抠图 | Miral',
    metaDescription: '用 Miral AI 免费去除人像背景：发丝抠图、证件照换白底/蓝底、LinkedIn 职业照与微信头像透明 PNG，一步完成。',
    updatedAt: '2026-10-09',
    target: { label: '打开人像去背景', path: '/tools/background-remover' },
    keywords: [
      '免费人像去背景', 'AI 人像抠图', '头像去背景', '证件照去背景', 'LinkedIn 职业照抠图',
      '简历照片去背景', '发丝抠图', '微信头像透明背景', '护照照片换背景', '蓝底证件照制作',
      '白底证件照在线', '社媒头像去背景', '人像背景移除', '职业照透明 PNG'
    ],
    creatingSteps: [
      { title: '选一张清晰半身照', text: '尽量用相机原图或未反复压缩的 JPG、PNG、WebP，脸和肩部完整入镜，单张不超过 15 MB。' },
      { title: '自动移除背景', text: '上传后 Miral AI 识别人物主体并去掉整张背景，不用手动画选区。' },
      { title: '放大检查发丝与眼镜', text: '重点看细发丝、耳饰、眼镜框和肩线，确认没有白边或缺一块。' },
      { title: '下载透明 PNG 再铺底色', text: '先保存透明母版，再按用途铺白底、蓝底、灰底或品牌色做成证件照或头像。' }
    ],
    pros: [
      '专攻人像边缘，适合头像、证件照和职业照',
      '不用 Photoshop 钢笔描发丝',
      '透明 PNG 可反复换成不同底色',
      '登录即可免费处理，浏览器内完成'
    ],
    cons: [
      '细发丝和飞发仍需放大复核',
      '强逆光或脸与背景同色时边缘可能不稳',
      '一次处理一张照片',
      '正式证件照仍需核对当地尺寸与底色规定'
    ],
    sections: [
      makeSection('tldr', '先看这一段就够用', [
        table(['你要的结果', '怎么做'], [
          ['费用', 'Miral AI 背景移除免费，登录后即可处理人像'],
          ['输入', 'JPG / PNG / WebP，单张最大 15 MB'],
          ['适合', '微信头像、LinkedIn 职业照、简历照、证件照母版'],
          ['输出', '透明 PNG；需要白底或蓝底时再铺色'],
          ['必查', '发丝、眼镜、耳饰、领口与肩线'],
          ['别和商品篇搞混', '这篇管“人”；商品白底见电商去背景指南']
        ], 'overview'),
        p('街边自拍、咖啡店合影、会议室随手拍，只要脸清楚，就能在 Miral AI 里先抠成透明 PNG，再换成干净白底或规定蓝底。比重新约影楼快，也比在手机里一点点擦背景省事。')
      ]),
      makeSection('what-it-does', '头像、证件照、LinkedIn 职业照各解决什么', [
        p('三种用途共用同一步：先用 Miral AI 背景移除得到干净透明 PNG。差别在“抠完铺什么底、裁多大”。下面按场景拆开看。'),
        p('社媒头像去背景解决什么：卧室自拍、街边合影里的杂物会抢脸。抠掉背景后铺品牌色或纯色，再套圆形裁切，头像立刻干净，也更适合微信、Instagram、个人主页。'),
        gallery(
          ['portrait-avatar-before', 'portrait-avatar-after'],
          '头像示例：左为杂乱室内原片，右为去背景后铺纯色，方便圆形头像裁切。',
          2,
          'contain',
          'portrait'
        ),
        p('证件照去背景解决什么：报名、签证、入职常要求白底或蓝底，家里拍的照片背景不合规。先抠出透明母版，再铺规定色并按官方尺寸裁切，比重跑一趟照相馆快；正式提交前仍要核对当期规则。'),
        gallery(
          ['portrait-id-before', 'portrait-id-after'],
          '证件照示例：左为客厅杂乱背景原片，右为去背景后铺纯白，可再按官方尺寸裁切。',
          2,
          'contain',
          'portrait'
        ),
        p('LinkedIn 职业照抠图解决什么：开放式办公室、会议室、工位自拍常有屏幕和同事入镜。去掉杂乱背景、换成浅灰或纯白后，招聘官第一眼看到的是脸和着装，而不是背后的显示器。'),
        gallery(
          ['portrait-linkedin-before', 'portrait-linkedin-after'],
          'LinkedIn 职业照示例：左为忙碌办公室自拍，右为去背景后铺浅灰，更适合招聘与个人品牌页。',
          2,
          'contain',
          'portrait'
        ),
        tip('三种用途共用一张透明母版', '先下载透明 PNG。头像铺品牌色、证件照铺白/蓝、LinkedIn 铺浅灰，都从同一母版派生，不必重复抠发丝。')
      ]),
      makeSection('how-to-use', '四步做出干净职业照', [
        p('打开 Miral AI 背景移除，上传半身或头肩照。处理完先放大到 100% 看发丝和眼镜，再下载透明 PNG。需要 LinkedIn 头像就铺浅灰或纯白；需要证件照就铺官方要求的白底或蓝底。'),
        stepsBlock(),
        tip('原图比滤镜重要', '美颜过度、强磨皮、聊天软件压成的小图，都会让发丝边缘发糊。能拿相机原图就别用朋友圈压缩版。')
      ]),
      makeSection('edge-check', '人像边缘该盯哪里', [
        table(['部位', '容易出的问题', '怎么查'], [
          ['细发丝与飞发', '被当成背景删掉', '深色底、浅色底各看一遍'],
          ['眼镜与镜片反光', '镜腿缺失或镜片开洞', '放大到镜框与镜腿交接处'],
          ['耳饰与项链', '细链断裂', '沿金属边缘扫一眼'],
          ['衣领与西装肩线', '出现白边或锯齿', '换深色画布立刻能看见'],
          ['络腮胡与鬓角', '毛茬被抹平', '用未过度磨皮的原图重试']
        ], 'overview'),
        p('缩略图里“看起来干净”不够。把头像放到深色和浅色两张画布上，白边、黑边、缺发丝会一下露出来。')
      ]),
      makeSection('use-cases', '头像、证件照、简历照分别怎么铺底', [
        table(['用途', '常见底色', '做法'], [
          ['LinkedIn / 招聘网站', '浅灰、纯白或干净虚化', '透明 PNG + 简洁底，衣服与背景别抢戏'],
          ['微信 / Instagram 头像', '品牌色、纯色或轻渐变', '先抠图再套圆形裁切预览'],
          ['简历附件照', '白底或浅灰', '肩部留白够，别裁到下巴'],
          ['国内常见证件照', '白底或蓝底', '透明 PNG 铺规定色，再按毫米尺寸裁'],
          ['护照 / 签证申请照', '以官方当期要求为准', '底色、表情、眼镜规则以官方说明为准'],
          ['直播与课程封面', '品牌色或场景图', '人像抠好后可进 Seedream 做封面场景']
        ], 'overview'),
        tip('规定会变', '各国签证、考试报名对照片底色和尺寸要求不同。工具只负责抠干净，合规以官方最新说明为准。')
      ]),
      makeSection('hair-glasses', '发丝抠图和戴眼镜人像怎么过关', [
        bullets([
          '头发散开、逆光发丝：优先选背景更简单、对比更强的一张原片。',
          '戴眼镜：检查镜腿是否完整，镜片不要被抠成空洞。',
          '深色头发配深色墙：换一张浅色墙或窗边光线更清楚的照片再抠。',
          '浅色毛衣配白墙：低对比最容易缺边，换背景环境重拍往往比反复提交更快。',
          '儿童、长卷发：飞发更多，下载前务必 100% 放大。'
        ]),
        p('人像去背景的难点几乎都在“细”。衣服大轮廓通常没问题，真正决定能不能发朋友圈或交材料的，是发丝和眼镜那一圈。')
      ]),
      makeSection('troubleshooting', '头像抠坏了怎么救', [
        table(['现象', '常见原因', '建议'], [
          ['发丝成一撮一撮缺了', '原图糊、压缩狠或逆光', '换更清晰原图，避免美颜过度'],
          ['脸或肩膀一圈白边', '旧背景颜色粘在边缘', '深色底定位白边，换对比更强的原片'],
          ['眼镜框缺角', '反光干扰轮廓', '换角度、减少镜片强反光后重试'],
          ['衣服和墙粘在一起', '颜色太接近', '换拍摄背景，而不是同一张图死磕'],
          ['做成证件照发现发黄', '原片色温偏', '先抠图，再在统一底色下微调白平衡']
        ], 'overview'),
        tip('别反复提交同一张糊图', '换输入往往比多点几次“生成”更有效。')
      ]),
      makeSection('pros-cons', '优缺点', [prosConsBlock()]),
      makeSection('best-practices', '做出能直接用的头像', [
        bullets([
          '半身或头肩构图，头顶和肩膀留一点空间。',
          '正脸或轻微侧脸，表情自然，避免猛烈美颜。',
          '下载透明 PNG 后，在深浅两种底上检查边缘。',
          '证件照用途：透明母版、成品白底/蓝底、裁切尺寸文件分开存。',
          '职业平台头像：背景越干净，脸和衣服质感越容易被注意到。',
          '需要场景感封面时，抠完再去做换背景，而不是直接在杂乱原图上硬P。'
        ])
      ]),
      makeSection('miral-workflow', '抠完之后还能做什么', [
        p('透明人像可以继续在 Miral AI 里增强清晰度，或进入 Seedream、FLUX.2 做成课程封面、活动海报。若下一步是整张换场景，可以看 AI 换背景指南；若是商品白底，则走电商商品图去背景。'),
        links('相关工具和指南', [
          { label: 'Miral AI 背景移除', path: '/tools/background-remover' },
          { label: 'AI 换背景在线指南', path: '/hub/articles/ai-background-changer-online' },
          { label: '通用 AI 背景移除教程', path: '/hub/articles/ai-background-remover-online' },
          { label: '商品图去背景与白底图', path: '/hub/articles/ecommerce-product-background-removal' },
          { label: 'AI 图片增强', path: '/tools/image-enhancer' },
          { label: 'Seedream 5', path: '/image-models/seedream-ai-image-generator' },
          { label: 'FLUX.2', path: '/image-models/flux-2-ai-image-generator' }
        ])
      ]),
      makeSection('faq', '常见问题', [
        faqItem('如何免费在线做人像去背景？', '登录 Miral AI，打开背景移除，上传 JPG / PNG / WebP 头肩照，等待自动抠图后下载透明 PNG。'),
        faqItem('如何把自拍做成白底或蓝底证件照？', '先导出透明 PNG，再铺纯白或规定蓝色，并按官方尺寸裁切；提交前核对当期规则。'),
        faqItem('如何做 LinkedIn 职业照抠图？', '去掉办公室杂乱背景，铺浅灰或纯白，确认发丝与肩线干净后再上传。'),
        faqItem('可以免费去除微信或 Instagram 头像背景吗？', '可以。登录后即可处理头像原片，透明 PNG 可再铺品牌色并预览圆形裁切。'),
        faqItem('可以在线抠戴眼镜的人像吗？', '可以，但要放大检查镜框、镜腿和镜片区域是否完整。'),
        faqItem('用什么工具做发丝抠图？', '用 Miral AI 背景移除。优先相机原图，并在深色、浅色两种底上检查飞发。'),
        faqItem('用什么工具准备护照签证照背景？', '先用人像去背景得到透明母版，再按官方要求的底色与毫米尺寸导出。'),
        faqItem('如何修复人像抠图后的白边？', '把透明 PNG 放到深色底定位白边，换对比更强、更清晰的原片重试。'),
        faqItem('如何解决卷发或儿童照飞发被抠没？', '避免猛美颜和聊天压缩图，用更高清原图，下载前 100% 放大检查。'),
        faqItem('能否一次批量处理多张职业照？', '当前按单张处理，方便逐张检查发丝；重要头像建议不要跳过复核。'),
        faqItem('透明底和白底证件照有什么区别？', '透明 PNG 可反复换底色；白底图已铺白色像素，适合直接交给表格或简历。'),
        faqItem('如何把抠好人像换成咖啡馆或办公室背景？', '透明 PNG 过检后，按 AI 换背景指南合成新场景，并检查光影是否自然。')
      ])
    ],
    related: [
      'ai-background-changer-online',
      'ai-background-remover-online',
      'ecommerce-product-background-removal'
    ]
  },
  {
    slug: 'ai-background-changer-online',
    category: 'how-to-guides',
    layout: 'how-to',
    badge: 'Hot',
    supportedLocales: ['zh', 'en', 'ja', 'ko', 'fr', 'es', 'it', 'de', 'pt', 'pl', 'ar'],
    coverImage: 'changer-lifestyle-after',
    heroImage: 'changer-lifestyle-after',
    title: '免费 AI 换背景：生活方式图、社媒封面与活动海报场景替换',
    excerpt: '先免费去掉原背景，再把人物放进咖啡馆、品牌渐变墙或活动海报背景。适合生活方式图、社媒封面和演讲预告，不抢电商白底词。',
    metaTitle: '免费 AI 换背景：生活方式图与社媒封面 | Miral',
    metaDescription: 'Miral AI 换背景教程：在线抠图导出透明 PNG，再做咖啡馆生活方式图、社媒封面品牌墙和活动海报场景。',
    updatedAt: '2026-10-09',
    target: { label: '打开 AI 去背景换场景', path: '/tools/background-remover' },
    keywords: [
      '免费 AI 换背景', 'AI 换背景在线', '照片替换背景', '抠图后换场景', '人像换背景',
      '生活方式场景图', '社媒封面换背景', '透明 PNG 换背景', 'AI 场景替换', '活动海报换背景',
      '办公室背景替换', '咖啡馆人像场景', '品牌色背景合成', '去背景后生成场景'
    ],
    creatingSteps: [
      { title: '先抠出干净主体', text: '用 Miral AI 背景移除得到透明 PNG，检查发丝、轮廓，不要带着旧背景残边进入下一步。' },
      { title: '想清楚新场景要什么感觉', text: '咖啡馆、简约办公室、户外日光、纯色品牌墙——先定用途再选背景。' },
      { title: '把主体放进新背景', text: '在设计画布或 Seedream / FLUX.2 场景流程中合成，尽量让光线方向接近。' },
      { title: '检查光影与比例', text: '看脚底/肩下接触阴影、色温是否一致，主体别过大过小。' },
      { title: '导出用途尺寸', text: '社媒封面、海报、详情页横幅按平台比例分别导出，保留透明母版。' }
    ],
    pros: [
      '一张透明母版可换多种场景',
      '比重新拍摄场景成本低',
      '适合社媒、海报和生活方式图',
      '可与 Seedream、FLUX.2 场景生成衔接'
    ],
    cons: [
      '光影不匹配会一眼假',
      '发丝边缘脏会污染整张合成',
      '电商主图白底规范请走商品篇，不在这篇硬套',
      '复杂透视场景仍需人工微调'
    ],
    sections: [
      makeSection('tldr', '换背景的正确顺序', [
        table(['步骤', '产出', '别踩的坑'], [
          ['1. 去背景', 'Miral AI 透明 PNG 母版', '带着白边进场景会非常假'],
          ['2. 选场景', '咖啡馆 / 办公室 / 品牌墙等', '先定用途，再选背景风格'],
          ['3. 合成', '生活方式图或封面', '光线方向和色温尽量一致'],
          ['4. 验收', '可发布文件', '看接触阴影、比例、边缘'],
          ['和白底的分工', '白底走电商篇', '这篇主打场景替换，不是 Amazon 白底']
        ], 'overview'),
        p('换背景不是“滤镜一键美化”，而是两步：先在 Miral AI 背景移除里把人（或主体）干净地抠出来，再放进新环境。第一步糊了，第二步再漂亮也救不回来。')
      ]),
      makeSection('remove-then-replace', '生活方式图、社媒封面、活动海报各换什么背景', [
        p('旧背景的杂色会粘在发丝和肩线上。稳妥做法始终是：Miral AI 背景移除 → 透明 PNG 母版 → 再按用途换场景。商品白底上架请走开电商篇，别和这篇抢词。'),
        p('生活方式图换背景解决什么：咖啡馆、窗边、居家角能烘托氛围，但原片背景杂乱时整张图都显得廉价。先抠干净，再放进光位接近的生活场景，个人品牌和种草内容会自然很多。'),
        gallery(
          ['changer-lifestyle-before', 'changer-lifestyle-after'],
          '生活方式图示例：左为透明主体母版，右为合成进明亮咖啡馆场景。',
          2,
          'contain',
          'portrait'
        ),
        p('社媒封面换背景解决什么：Instagram、小红书、LinkedIn 头图需要“人脸清楚 + 留出标题区”。杂乱办公室或卧室会让封面又挤又乱。换上品牌渐变或干净色块墙，人放一侧，另一侧留给文案。'),
        gallery(
          ['changer-social-before', 'changer-social-after'],
          '社媒封面示例：左为透明主体，右为品牌渐变墙，右侧留白方便叠标题。',
          2,
          'contain',
          'portrait'
        ),
        p('活动海报 / 演讲预告换背景解决什么：发布会、课程开播、Webinar 封面常要干净舞台感或品牌墙，而不是工位自拍。抠完铺柔光品牌墙，人物完整、旁边留标题位，再进 GPT Image 加字会更稳。'),
        gallery(
          ['changer-poster-before', 'changer-poster-after'],
          '活动海报示例：左为透明主体，右为柔光品牌墙，适合做演讲或课程预告封面。',
          2,
          'contain',
          'portrait'
        ),
        tip('母版、场景、封面裁切分开存', '透明 PNG 不要被某一版咖啡馆或渐变封面覆盖。下次换季节海报，直接换背景即可。')
      ]),
      makeSection('how-to-use', '在线换背景怎么走', [
        p('打开 Miral AI 背景移除，先得到可用的透明主体，再决定背景类型：纯色最快，实景照片次之，AI 生成场景最灵活。合成后一定检查脚底或身体与地面的接触感，以及头发边缘是否还咬着旧背景。'),
        stepsBlock(),
        tip('光线优先于“好看”', '窗光人像配漆黑夜景，再精致也容易违和。优先选光位接近的背景。')
      ]),
      makeSection('scene-ideas', '哪些换背景最吸睛', [
        table(['场景方向', '适合用途', '注意'], [
          ['明亮咖啡馆 / 窗边', '个人品牌、生活方式封面', '暖色灯光别让肤色发橘'],
          ['简约办公室 / 书架虚化', 'LinkedIn、课程导师图', '背景元素别比人脸抢镜'],
          ['户外日光与绿植', '旅行、健康、生活方式内容', '避免正午顶光和原片光位冲突'],
          ['纯色或轻渐变品牌墙', '活动海报、社媒头图', '品牌色对比要够，字才好排'],
          ['展会 / 舞台感灯光', '发布会、演讲预告', '光斑别切过人脸'],
          ['家居生活方式角', '家居内容、软性种草', '透视和人物比例要统一']
        ], 'overview'),
        p('吸睛不等于复杂。很多高点击封面只是“干净人像 + 有氛围但不乱的背景”。背景信息越少，主体越容易被记住。')
      ]),
      makeSection('quality-check', '合成假不假，看这五处', [
        bullets([
          '发丝与肩线：有没有旧背景白边、绿边。',
          '光影方向：脸的高光和背景窗光是否同侧。',
          '色温：暖黄室内人配冷蓝背景会“两张皮”。',
          '比例：人是否过大像贴贴纸，或过小像远景错位。',
          '接触感：脚底、椅边、桌沿是否有一点点投影或遮挡关系。'
        ]),
        tip('先小图预览再出终稿', '先导出一版正方形和一版横版封面看裁切，再决定要不要重做背景。')
      ]),
      makeSection('vs-other-guides', '这篇和另外两篇去背景文怎么分工', [
        table(['文章', '主战场', '你什么时候点开它'], [
          ['通用 AI 背景移除', '什么图都能抠、透明 PNG 基础', '只想快速去背景、还不换场景'],
          ['电商商品图去背景', '商品白底 / 透明底上架', 'Amazon、Shopify 主图合规'],
          ['人像去背景', '头像、证件照、职业照', '做人脸、发丝、白底蓝底证件'],
          ['AI 换背景（本文）', '抠完换场景、生活方式与封面', '要咖啡馆、办公室、品牌墙氛围']
        ], 'overview'),
        p('四篇可以互链，但搜索词分开：白底商品别硬塞进换背景；证件蓝底别写成生活方式咖啡馆。这样读者找得到，搜索也不会自己打自己。')
      ]),
      makeSection('troubleshooting', '换背景失败常见原因', [
        table(['问题', '原因', '处理'], [
          ['边缘一圈亮边', '抠图阶段就有白边', '回到去背景，换对比更强原图重抠'],
          ['看起来像贴纸', '缺少接触阴影或光影不一致', '减弱背景对比，或补很轻的投影'],
          ['肤色发灰 / 发橘', '背景色温冲突', '换色温接近的场景，或统一调色'],
          ['头发脏脏的', '透明通道不干净', '放大检查发丝后再合成'],
          ['商品结构被 AI 场景改歪', '生成场景时提示词约束不够', '保留真实外形，场景只作环境']
        ], 'overview')
      ]),
      makeSection('pros-cons', '优缺点', [prosConsBlock()]),
      makeSection('best-practices', '让换背景图更耐看', [
        bullets([
          '永远先有干净透明母版，再谈场景。',
          '场景服务于用途：招聘偏干净，生活号偏氛围，海报偏留白给标题。',
          '人物原片光线越简单，换背景越容易成功。',
          '社媒发布前用手机屏幕再看一遍，小屏最容易暴露假边。',
          '需要文字海报时，换好背景再进 GPT Image 排标题，而不是反过来。',
          '商品上架白底请走开电商指南，避免一张图同时打两种搜索意图。'
        ])
      ]),
      makeSection('miral-workflow', '在 Miral AI 里串起来', [
        p('推荐链路：在 Miral AI 用背景移除拿到透明主体 →（可选）图片增强 → Seedream 或 FLUX.2 生成/合成场景 → 需要标题字再用 GPT Image。人像证件照需求则回到人像去背景篇铺白底或蓝底。'),
        links('相关工具和指南', [
          { label: 'Miral AI 背景移除', path: '/tools/background-remover' },
          { label: '人像去背景与证件照', path: '/hub/articles/ai-portrait-background-remover' },
          { label: '通用 AI 背景移除教程', path: '/hub/articles/ai-background-remover-online' },
          { label: '商品图去背景指南', path: '/hub/articles/ecommerce-product-background-removal' },
          { label: 'AI 图片增强', path: '/tools/image-enhancer' },
          { label: 'Seedream 5', path: '/image-models/seedream-ai-image-generator' },
          { label: 'FLUX.2', path: '/image-models/flux-2-ai-image-generator' },
          { label: 'GPT Image 1.5', path: '/image-models/gpt-image-ai-image-generator' }
        ])
      ]),
      makeSection('faq', '常见问题', [
        faqItem('如何免费在线换照片背景？', '登录 Miral AI，先用背景移除导出透明 PNG，再铺咖啡馆、品牌墙或新场景。'),
        faqItem('如何把透明 PNG 做成生活方式图？', '选光位接近的场景板合成，检查接触感和色温，母版与封面裁切分开保存。'),
        faqItem('如何在抠图后更换社媒封面背景？', '发丝过关后，把主体放到品牌渐变墙一侧，另一侧留给标题。'),
        faqItem('可以把自拍换成咖啡馆背景吗？', '可以。先抠干净再合成，并让窗光方向接近脸部高光。'),
        faqItem('可以让 AI 生成场景放在真人后面吗？', '可以。透明主体配合 Seedream 或 FLUX.2，只生成环境，别改脸和衣服。'),
        faqItem('用什么工具做活动海报换背景？', '先用 Miral AI 背景移除拿透明主体，再铺柔光品牌墙；标题字可进 GPT Image。'),
        faqItem('用什么工具做社媒封面换背景？', '背景移除 + 品牌色/渐变墙。需要氛围场景时再衔接 Seedream 或 FLUX.2。'),
        faqItem('如何修复换背景后看起来假？', '按白边 → 光位 → 色温顺序排查；边缘脏就回到去背景重抠。'),
        faqItem('如何解决户外日光换背景光位冲突？', '太阳方向要对上，避免正午顶光打在原本偏室内的脸光上。'),
        faqItem('能否用换背景做视频封面？', '可以，按封面比例裁切，确保主体落在安全区。'),
        faqItem('换背景和去背景有什么区别？', '去背景得到透明主体；换背景是把主体放进新场景或新底色。'),
        faqItem('可以用来做 Amazon 白底商品图吗？', '不可以按这篇做上架白底。白底请看电商商品图去背景指南；本篇做生活方式与封面场景。')
      ])
    ],
    related: [
      'ai-portrait-background-remover',
      'ai-background-remover-online',
      'seedream-ai-image-generator-review'
    ]
  }
]

module.exports = {
  ARTICLES: ARTICLES
}
